import { observer } from 'mobx-react';
import {
  Button,
  StandardDialog
} from '@roc/ui';
import { FirstAppraisalValueConfirmation } from './firstAppraisalValueConfirmation';
import { Grid } from '@material-ui/core';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { useUserStore } from '@roc/feature-app-core';
import { isBlank, isNil } from '@roc/feature-utils';
import { CONFIRMED_VALUATION_STATUS, REJECTED_VALUATION_STATUS } from '../../../stores/documentForms/firstAppraisalValueConfirmation/firstAppraisalValueConfirmationStore';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface FirstAppraisalValueConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const FirstAppraisalValueConfirmationDialog = observer((props: FirstAppraisalValueConfirmationDialogProps) => {

  const { open, onClose, document } = props;
  const taskId = document?.taskId;

  const {
    documentStore: {
      documentFormStore: { firstAppraisalValueConfirmationStore },
    },
  } = useDocumentStore();

  const { userStore } = useUserStore();

  const dialogActions = (
    <Grid
      container
      spacing={1}
      xs={12}
      justifyContent="flex-end"
    >
      {isBlank(firstAppraisalValueConfirmationStore?.confirmValuationStatus) &&
        <>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => firstAppraisalValueConfirmationStore.saveConfirmValuationStatus(REJECTED_VALUATION_STATUS, onClose)}
              testId="reject"
            >
              Reject
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => firstAppraisalValueConfirmationStore.saveConfirmValuationStatus(CONFIRMED_VALUATION_STATUS, onClose)}
              variant="contained"
              color="primary"
              disabled={isNil(firstAppraisalValueConfirmationStore?.appraisalValue1)}
              testId="confirm"
            >
              Confirm
            </Button>
          </Grid>
        </>
      }
      {firstAppraisalValueConfirmationStore?.confirmValuationStatus === REJECTED_VALUATION_STATUS && userStore.isNportalUser &&
        <>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => onClose()}
              testId="cancel"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => firstAppraisalValueConfirmationStore.processAppraisalRefund(onClose)}
              testId="processRefund"
            >
              Process Refund
            </Button>
          </Grid>
        </>
      }
    </Grid>
  );

  return (
    <> {taskId ? (
      <CustomTaskDialog
        open={open}
        title="Confirm First Appraisal Value"
        handleClose={onClose}
        dialogActions={dialogActions}
        dialogContent={<FirstAppraisalValueConfirmation />}
        taskId={taskId}
      />
    ) : (
      <StandardDialog
        open={open}
        title="Confirm First Appraisal Value"
        maxWidth="sm"
        handleClose={onClose}
        dialogContent={<FirstAppraisalValueConfirmation />}
        dialogActions={dialogActions}
        removeContentBox
      />
    )}

    </>
  );
});